import React from 'react';
import { Redirect } from 'react-router-dom';
import ShowingsTable from './ShowingsTable';
import DashboardLayout from './DashboardLayout';
import JobsFeedInner from '../showings/JobsFeed';
import PostShowingInner from '../showings/PostShowing';

export function MyRequests(props) {
  return <ShowingsTable {...props} as="buyer_agent" title="My Showing Requests"
    subtitle="Showings you've posted for other agents to cover." />;
}

export function Appointments(props) {
  return <ShowingsTable {...props} as="showing_agent" title="Showing Appointments"
    subtitle="Showings you've accepted and their full history." />;
}

export function Opportunities(props) {
  return (
    <DashboardLayout>
      <JobsFeedInner {...props} embedded />
    </DashboardLayout>
  );
}

export function PostShowingPage(props) {
  return (
    <DashboardLayout>
      <PostShowingInner {...props} embedded />
    </DashboardLayout>
  );
}

// legacy /showings route → the requests table
export function ShowingsRedirect({ location }) {
  const params = new URLSearchParams(location.search);
  const to = params.get('as') === 'showing_agent' ? '/showings/appointments' : '/showings/requests';
  const posted = params.get('posted') === '1' ? '?posted=1' : '';
  return <Redirect to={to + posted} />;
}
